import { FormControlLabel, Switch } from "@mui/material";
import { GridRenderEditCellParams } from "@mui/x-data-grid";
import { ChangeEvent, useState } from "react";

import useRole from "../../../../../core/routing/useRole";
import { useEffectAsync } from "../../../../../utils/hooks/useEffectAsync.hook";
import { ScopeRole } from "../../../../../utils/types/user.type";
import { useDocumentsContext } from "../../../hooks";

function WaterMarkCellRenderer({ row }: GridRenderEditCellParams) {
  const { state, toggleWaterMark } = useDocumentsContext();

  const {
    hasRole: isClientAdmin,
  } = useRole([ScopeRole.ARK_CLIENT_ADMIN]);

  const {
    hasRole: isSuperAdmin,
  } = useRole([ScopeRole.SUPER_ADMIN]);

  const {
    hasRole: isBasicAdmin,
  } = useRole([ScopeRole.BASIC_ADMIN]);


  const isEditable: boolean = !!isSuperAdmin || !!isClientAdmin || !!isBasicAdmin;

  const [watermark, setWatermark] = useState<boolean>(false);
  
  // eslint-disable-next-line require-await
  useEffectAsync(async (isCanceled) => {
    if(isCanceled()) return;
    setWatermark(row.hasWatermark);
  }, [row.hasWatermark]);

  return (
    <FormControlLabel
      control={
        <Switch
          checked={watermark}
          onChange={(e: ChangeEvent<HTMLInputElement>): void => {
            setWatermark(e.target.checked);
            toggleWaterMark({
              ...row,
              hasWatermark: e.target.checked,
            });
          }}
          disabled={!isEditable || state?.isPageLocked}
          name="watermark"
        />
      }
      label="Watermark"
    />
  );
}

export default WaterMarkCellRenderer;